/* Format d'image optimal selon le navigateur — dans l'URL pour que le cache CDN ne mélange jamais les formats */
let ok = false;
try {
  ok = document.createElement('canvas').toDataURL('image/webp').indexOf('data:image/webp') === 0;
} catch (e) { ok = false; }
export const IMG_FMT = ok ? 'webp' : 'png';

export const optimImg = (u, w = 96) => {
  if (!u) return u;
  if (u.startsWith('/api/borne/media/') && !u.includes('?')) return `${u}?w=${w}&fmt=${IMG_FMT}`;
  if (IMG_FMT === 'png' && u.endsWith('.webp') && !u.startsWith('http')) return u.slice(0, -5) + '.png';
  return u;
};
